import { Text } from '@applane/react-core-components';
import { ROUTES } from '../../Lib/constants';
import React from 'react';
import vars from '../../theme/vars';
import ListAll from './All';
import { ShowHistoryItem } from './View';
import { cancelButton } from '../../app-components';
const { headings } = vars;

export default {
  [ROUTES.subscriptionHistoryListAll.name]: {
    screen: ListAll,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Subscription History</Text>
    ),
    headerActions: [{ render: () => <Text></Text> }],
  },

  [ROUTES.subscriptionHistoryListAllBackButton.name]: {
    screen: ListAll,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Subscription History</Text>
    ),
    headerActions: [cancelButton],
  },

  [ROUTES.viewSubscriptionHistory.name]: {
    screen: ShowHistoryItem,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Subscription History</Text>
    ),
    headerActions: [cancelButton],
  },
};
